import { ComponentIds, HierarchyUtils } from '@inter-ikea-core/core';
import { ProductType, calculatePartialDistance } from '../..';
import { PlannerValidation } from './PlannerValidation';
/**
 * Some småstad accessories connect to different connectors on front depending on front rotation
 * This validation handles that the accessories only snap to upright connectors
 */
export class RotationValidation extends PlannerValidation {
    constructor(coreApi) {
        super(coreApi, 'RotationValidation');
        this.PRODUCT_TYPES = [
            ProductType.SMASTAD_HOOK_CLIP,
            ProductType.SMASTAD_LABEL_HOLDER
        ];
        this.ACCESSORIES_HOST_OFFERS_KEYS = ['attach-label-holder', 'attach-hook-clip'];
        // Delete these products when duplicating a parent to avoid wrong rotations
        coreApi.subscribe('duplicate', (clone) => {
            HierarchyUtils.descendants(clone).forEach(d => coreApi.entities.isOneOfProductTypes(d, this.PRODUCT_TYPES)
                ? coreApi.entities.delete(d)
                : null);
        });
    }
    validateCurrentState() {
        return this.validationOK();
    }
    getRotation(entity) {
        return entity
            .getComponent(ComponentIds.WORLD_TRANSFORM_COMPONENT_ID)
            ?.transform.rotation.toEulerDegrees();
    }
    isRotated(entity) {
        // Only allow rotation around Y axis
        return !!Math.round(calculatePartialDistance(this.getRotation(entity), { X: 0, Z: 0 }));
    }
    validateSnap(snapActionCandidate) {
        const entity = snapActionCandidate.guestRoot;
        if (!this.coreApi.entities.isOneOfProductTypes(entity, this.PRODUCT_TYPES)) {
            return this.validationOK();
        }
        const notRotated = !this.isRotated(entity);
        return notRotated ? this.validationOK() : this.validationFail('Can´t snap to this connector');
    }
}
//# sourceMappingURL=RotationValidataion.js.map